import { render, staticRenderFns } from "./Pattern.List.vue?vue&type=template&id=b2c4bf74&"
import script from "./Pattern.List.vue?vue&type=script&lang=js&"
export * from "./Pattern.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports